"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllCurrenciesAccountSummary = exports.getSingleCurrencyAccountSummary = void 0;
const calculationsCore_1 = require("../calculationsCore");
const types_1 = require("../types");
const getSingleCurrencyAccountSummary = (rows, equities, marginType, tickers, pageOperationCurrency, tablesCalculations) => {
    let currentEquity = equities[pageOperationCurrency];
    const equityForCalculation = currentEquity.updatedEquity;
    const accountMargins = (0, calculationsCore_1.calculateMarginsForAccount)(rows, equityForCalculation, marginType, tickers, tablesCalculations);
    // #78 10 means 10 times which is 1000%
    accountMargins.imPercent =
        accountMargins.imPercent > 10
            ? Number.POSITIVE_INFINITY
            : accountMargins.imPercent;
    accountMargins.mmPercent =
        accountMargins.mmPercent > 10
            ? Number.POSITIVE_INFINITY
            : accountMargins.mmPercent;
    return Object.assign(Object.assign({}, accountMargins), currentEquity);
};
exports.getSingleCurrencyAccountSummary = getSingleCurrencyAccountSummary;
const getAllCurrenciesAccountSummary = (rows, equities, marginType, tickers, indices, tablesCalculations) => {
    let accountMarginsSummed = [types_1.Currency.BTC, types_1.Currency.ETH, types_1.Currency.USDC].reduce((memo, currentCurrency) => {
        const ccyRows = rows.filter((r) => (0, calculationsCore_1.getSettlementCurrencyFromInstrumentString)(r.instrument) ===
            currentCurrency);
        let currentEquity = equities[currentCurrency];
        const equityForCalculation = currentEquity.updatedEquity;
        const accountMargins = (0, calculationsCore_1.calculateMarginsForAccount)(ccyRows, equityForCalculation, marginType, tickers, tablesCalculations);
        const sumMargins = {
            mm: memo.mm + accountMargins.mm,
            mmProjected: memo.mmProjected + accountMargins.mmProjected,
            im: memo.im + accountMargins.im,
            imProjected: memo.imProjected + accountMargins.imProjected,
            availableBalance: memo.availableBalance +
                accountMargins.availableBalance * indices[currentCurrency],
            marginBalance: memo.marginBalance +
                accountMargins.marginBalance * indices[currentCurrency],
            pnl: memo.pnl + accountMargins.pnl * indices[currentCurrency],
            pnlUsd: memo.pnlUsd + accountMargins.pnlUsd,
            deltaTotal: memo.deltaTotal +
                accountMargins.deltaTotal * indices[currentCurrency],
            deltaTotalProjected: memo.deltaTotalProjected +
                accountMargins.deltaTotalProjected * indices[currentCurrency],
            netDeltaTotal: memo.netDeltaTotal +
                accountMargins.netDeltaTotal * indices[currentCurrency],
            netDeltaTotalProjected: memo.netDeltaTotalProjected +
                accountMargins.netDeltaTotalProjected * indices[currentCurrency],
            imProjectedUsd: 0,
            mmProjectedUsd: 0,
            imUsd: memo.imUsd + accountMargins.imUsd,
            mmUsd: memo.mmUsd + accountMargins.mmUsd,
        };
        return sumMargins;
    }, {
        mm: 0,
        mmProjected: 0,
        mmUsd: 0,
        mmProjectedUsd: 0,
        im: 0,
        imUsd: 0,
        imProjectedUsd: 0,
        imProjected: 0,
        availableBalance: 0,
        marginBalance: 0,
        pnl: 0,
        pnlUsd: 0,
        deltaTotal: 0,
        deltaTotalProjected: 0,
        netDeltaTotal: 0,
        netDeltaTotalProjected: 0,
    });
    // We need to do this at the end because available balance is restricted to min: 0, for all currencies we
    // need to do it at the end
    const availableBalance = accountMarginsSummed.marginBalance - accountMarginsSummed.imUsd;
    const sumAccountsMargins = Object.assign(Object.assign({}, accountMarginsSummed), { availableBalance });
    const equityInDollars = equities[types_1.Currency.ALL].updatedEquity;
    let imPercent = sumAccountsMargins.imUsd / equityInDollars;
    let mmPercent = sumAccountsMargins.mmUsd / equityInDollars;
    // #78 10 means 10 times which is 1000%
    imPercent = imPercent > 10 ? Number.POSITIVE_INFINITY : imPercent;
    mmPercent = mmPercent > 10 ? Number.POSITIVE_INFINITY : mmPercent;
    return Object.assign(Object.assign(Object.assign({}, sumAccountsMargins), equities[types_1.Currency.ALL]), { imPercent,
        mmPercent });
};
exports.getAllCurrenciesAccountSummary = getAllCurrenciesAccountSummary;
